var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('screen-header', {
          attrs: {
            "history-mode": false,
            "title": _vm.$t('common.subscriptions')
          },
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.push({
                name: 'cabinet'
              });
            }
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.push({
                name: 'cabinet'
              });
            }
          }
        }), _c('div', {
          directives: [{
            name: "d-flex",
            rawName: "v-d-flex"
          }]
        }, [_c('screen-title', {
          attrs: {
            "title": _vm.$t('common.subscriptions')
          }
        }), _vm.periodicRecurrentPaymentPermission ? _c('simple-button', {
          directives: [{
            name: "m-l",
            rawName: "v-m-l",
            value: 'auto',
            expression: "'auto'"
          }],
          attrs: {
            "variant": "secondary",
            "size": "small",
            "fluid": false
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: 'Invoicing',
                hash: '#subscription'
              });
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('organize.subscription')) + " ")]) : _vm._e()], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }